module.exports = __webpack_public_path__ + "static/realert-1fb9dae4399b29862cb54800ac72320d.gif";